import axios from "axios";

window.addEventListener("DOMContentLoaded", () => {
	let show_more = document.querySelectorAll(".showmore");
	let show_dce = document.querySelectorAll(".show_dce");
	let forms = document.querySelectorAll(".appel_offres form");

	if (show_more) {
		show_more.forEach((el) => {
			el.addEventListener("click", (e) => {
				e.currentTarget.parentNode.classList.toggle("revealed");
			});
		});
	}
	if (show_dce) {
		show_dce.forEach((el) => {
			el.addEventListener("click", (e) => {
				let form = e.currentTarget.parentNode.parentNode.parentNode.querySelector("form");
				form.classList.add("active");
			});
		});
	}
	if (forms) {
		forms.forEach((el) => {
			let reponse_zone = el.querySelector(".reponse");
			let close = el.querySelector(".close-formulaire");
			close.addEventListener("click", () => {
				el.classList.remove("active");
			});
			el.addEventListener("submit", (e) => {
				e.preventDefault();
				let button = el.querySelector(".submit-button");
				button.innerHTML = "<i class='fal fa-spin fa-spinner'></i>";
				let form_data = new FormData(el);
				axios.post("/wp-admin/admin-ajax.php", form_data).then((response) => {
					if (response.data === "OK") {
						reponse_zone.innerHTML = "Merci. Le DCE vient de vous être envoyé par email.";
						button.innerHTML = "Succès";
						setTimeout(() => {
							el.classList.remove("active");
							reponse_zone.innerHTML = "";
							button.innerHTML = "Recevoir le DCE";
						}, 4000);
					} else {
						reponse_zone.innerHTML = "Une erreur est survenue pendant l'envoi de votre DCE.";
						button.innerHTML = "Erreur";
						setTimeout(() => {
							reponse_zone.innerHTML = "";
							button.innerHTML = "Recevoir le DCE";
						}, 10000);
					}
				});
			});
		});
	}
});
